import React, { FC } from "react";

import Typography from "@material-ui/core/Typography";

import Button from "@material-ui/core/Button";

import Box from "@material-ui/core/Box";



import { LOGIN_URL, REGISTER_URL } from "../../links";
import heroImage from "../../images/hero.png";

interface IHeroProps {}



const Hero: FC<IHeroProps> = (props) => {

  return (

    <div

      style={{

        position: "relative",

        width: "100%",

        height: "100vh",

        minHeight: "100vh",

        maxHeight: "100vh",

        display: "flex",

        justifyContent: "center",

        alignItems: "center",

        flexDirection: "column",

        overflow: "hidden",

        backgroundColor: "#02162b",

        zIndex: 1,

      }}

    >

      {/* Background image - star always in top-left corner, shifted up to hide white line */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#02162b",
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          // Center the hero artwork so the angled star + brand feel match legacy.
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: 0,
          overflow: "hidden",
        }}
      />

      {/* Gradient overlay - very light to show the image */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "100%",
          // Increase gradient visibility so it reads on dark backgrounds.
          background:
            "linear-gradient(to bottom, rgba(27, 28, 77, 0.35) 0%, rgba(2, 22, 43, 0.45) 89%)",
          zIndex: 1,
          pointerEvents: "none",
        }}
      />



      <Box textAlign="center" mb={6} style={{ zIndex: 3, position: "relative", width: "100%", marginBottom: "48px", padding: "0 20px" }}>

        <Typography

          style={{

            color: "#ffffff",

            fontWeight: 300,

            fontSize: 90,

            lineHeight: 1.1,

            display: "block",

            marginBottom: "8px",

          }}

          variant="h1"

        >

          Lose yourself in

        </Typography>

        <Typography

          style={{

            color: "#ffffff",

            fontWeight: 300,

            fontSize: 90,

            lineHeight: 1.1,

            display: "block",

          }}

          variant="h1"

        >

          the music you find.

        </Typography>

      </Box>



      <Box display="flex" flexDirection="column" alignItems="center" style={{ zIndex: 3, position: "relative", marginTop: "24px" }}>

        <Button

          onClick={(e) => {
            e.preventDefault();
            window.location.href = LOGIN_URL;
          }}

          variant="contained"

          color="primary"

          style={{

            borderRadius: 25,

            padding: "14px 56px",

            textTransform: "uppercase",

            fontSize: 16,

            fontWeight: 500,

            minWidth: 200,

            marginBottom: 16,

            textDecoration: "none",

            cursor: "pointer",

          }}

        >

          log in

        </Button>

        <Button

          onClick={(e) => {
            e.preventDefault();
            window.location.href = REGISTER_URL;
          }}

          variant="contained"

          color="secondary"

          style={{

            borderRadius: 25,

            padding: "14px 56px",

            textTransform: "uppercase",

            fontSize: 16,

            fontWeight: 500,

            minWidth: 200,

            textDecoration: "none",

            cursor: "pointer",

          }}

        >

          create account

        </Button>

      </Box>

    </div>

  );

};



export default Hero;
